import { parse, isValid, differenceInYears } from 'date-fns';

export const isAdult = (dob, format = 'dd/MM/yyyy') => {
    // Parse the date using date-fns
    const birthDate = parse(dob, format, new Date());

    // Ensure parsing was successful
    if (!isValid(birthDate)) {
        console.error('Invalid date format or value:', dob);
        return false;
    }

    // Calculate age
    const age = differenceInYears(new Date(), birthDate);
    return age >= 18;
};

// // ✅ Usage Examples:
// console.log(isAdult("15/04/1980", "dd/MM/yyyy")); // true
// console.log(isAdult("1980-04-15", "yyyy-MM-dd")); // true
// console.log(isAdult("1980-04-15T00:00:00", "yyyy-MM-dd'T'HH:mm:ss")); // true
// console.log(isAdult("15-04-2010", "dd-MM-yyyy")); // false
// console.log(isAdult("04/15/2005", "MM/dd/yyyy")); // false
